namespace Matrix.Data {
    export class SecurityOverrideColumns {
        static columnsKey = 'Data.SecurityOverride';
    }
}
